import template from "./index.html";
import "./index.less";
import {
	AGREEMENT_REQUIREMENT_TYPES,
	EVENT_LOGOUT
} from "../../../constants";

export function controller(
	$scope,
	$uibModal,
	eventBus,
	agreementService
) {
	const ctrl = this;

	ctrl.$onInit = onInit;
	ctrl.close = close;
	ctrl.getStatusIcon = getStatusIcon;
	ctrl.getStatusText = getStatusText;
	ctrl.viewAgreement = viewAgreement;

	function onInit() {
		setAgreements();

		eventBus.register(EVENT_LOGOUT, () => { close(); }, $scope);
	}

	function setAgreements() {
		ctrl.agreements = agreementService.agreements;
	}

	function getRequirementLabel(agreement) {
		if(agreement.RequirementCodes.indexOf(AGREEMENT_REQUIREMENT_TYPES.SIGN) >= 0) {
			return {
				accepted: "Signed",
				required: "Signature required"
			};
		}

		if(agreement.RequirementCodes.indexOf(AGREEMENT_REQUIREMENT_TYPES.AFFIRM) >= 0) {
			return {
				accepted: "Accepted",
				required: "Acceptance required"
			};
		}

		return {
			accepted: "Viewed",
			required: "Available"
		};
	}

	function getStatusIcon(agreement) {
		if(agreement.IsAccepted) {
			return "zmdi-check-circle agreement-accepted";
		}

		return agreement.IsRequired
			? "zmdi-alert-circle agreement-required"
			: "zmdi-info agreement-optional";
	}

	function getStatusText(agreement) {
		const requirementLabel = getRequirementLabel(agreement);

		if(agreement.IsAccepted) {
			return requirementLabel.accepted;
		}

		return agreement.IsRequired
			? requirementLabel.required
			: "Available";
	}

	function viewAgreement(agreement) {
		const modalInstance = $uibModal.open({
			component: "agreement-display-modal",
			size: "lg",
			backdrop: "static",
			keyboard: false,
			windowClass: "vesl-top",
			resolve: {
				acceptValue: () => true,
				agreement: () => agreement
			}
		});

		return modalInstance.result
			.then(accepted => {
				if(accepted !== true) {
					return;
				}

				setAgreements();
			})
			.catch(() => {});
	}

	function close() {
		ctrl.modalInstance.close();
	}
}

export default angular
	.module("vesl.components.show-agreements-modal", [])
	.component("showAgreementsModal", {
		controller,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			resolve: "<"
		}
	}).name;